import apiFetch from "../services/ApiClient";

const AdminFunctions = {
    isAdminAsync: async function () {
        const r = await apiFetch(`/api/Admin/IsAdminAsync`, { method: "GET" });
        if (r.status !== 200) return false;
        return r.data === true;
    },

    handleAdminUser: async function (isAdmin, adminFunction, nonAdminFunction) {
        if (isAdmin) {
            if (adminFunction) adminFunction();
        } else {
            if (nonAdminFunction) nonAdminFunction();
        }
    },

    getRoleIdByName: async function (name) {
        const r = await apiFetch(`/api/Admin/GetRoleIdByNameAsync?roleName=${encodeURIComponent(name)}`, {
            method: "GET"
        });
        if (r.status !== 200 || !r.data) return null;
        return r.data.id;
    }
};

export default AdminFunctions;